import oAxiosInstance from "config/Axios";

export const apiCallGetAllTasks = () => {
  return oAxiosInstance.get("seguridad/tareas");
};
